import { Permission } from './types';

export const ALL_PERMISSIONS_TYPES: Permission[] = [
  'canPreview',
  'canAdd',
  'canEdit',
  'canConvert',
  'canDelete',
];
